import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { AbsenceEmployeeStatusEnum } from '@qaroni-app/absences/types/absence-employee-status.enum';
import { PermitsApprovalsService } from '@qaroni-app/permits/services/permits-approvals.service';
import { PermitApprovalCounter } from '@qaroni-app/permits/types/permit-approval-counter';

@Component({
  selector: 'qaroni-pending-absences-widget',
  templateUrl: './pending-absences-widget.component.html',
  styleUrl: './pending-absences-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PendingAbsencesWidgetComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  private permitsApprovalsService = inject(PermitsApprovalsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  private companyID = 0;
  public $count = signal(0);

  private counter$ = this.permitsApprovalsService.counter$;
  private params$ = this.route.paramMap;

  public pluralMapping = {
    '=1': $localize`Permiso/Ausencia pendiente`,
    other: $localize`Permiso/Ausencias pendientes`,
  };

  ngOnInit(): void {
    this.subs.add(this.counter$.subscribe(this.getCounter));
    this.subs.add(this.params$.subscribe(this.getParamMaps));
  }

  public goToRequests(): void {
    const queryParams: Params = {
      statuses: AbsenceEmployeeStatusEnum.PENDING,
    };
    this.router.navigate(
      ['/companies', this.companyID, 'permits', 'requests'],
      { queryParams }
    );
  }

  private getCounter = (counter: PermitApprovalCounter | null): void => {
    this.$count.set(counter?.pendingCount ?? 0);
  };

  private getParamMaps = (params: ParamMap): void => {
    const paramCompanyID = params.get('companyID');

    if (paramCompanyID) {
      this.companyID = Number(paramCompanyID);
    }
  };
}
